/**
 * Don't display marked elements when a demo user is logged in.
 */
angular.module('cfn').directive('hideDemoaccount', [
  'DemoAccountService',
  function(DemoAccountService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        if (DemoAccountService.isDemoAccount()) {
          elem.css('display', 'none');
        }
      }
    };
  }
]);

/**
 * Only display marked elements when a demo user is logged in.
 */
angular.module('cfn').directive('showDemoaccount', [
  'DemoAccountService',
  function(DemoAccountService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        if (DemoAccountService.isDemoAccount()) {
          elem.css('display', 'block');
        }
      }
    };
  }
]);
